// What content this build is folding under.
//
// Derived from the content itself rather than hand-maintained, because a
// hand-maintained version rots the first time somebody edits a unit and
// forgets. A release carries the same value, computed by the publisher.
//
// l10n is deliberately not hashed: the fold is language-neutral, so a
// re-translated gloss must not invalidate every snapshot in the world.

import { BUNDLED, type CourseData } from "./course.ts";

/**
 * FNV-1a, 32-bit, rendered base 36. Not a cryptographic hash and not trying
 * to be: this answers "is this the same content", and the cost of a collision
 * is one snapshot that is trusted when it should have been re-folded — which
 * is a cache miss, not data loss: every snapshot is a cache.
 */
function fnv1a(s: string): string {
	let h = 0x811c9dc5;
	for (let i = 0; i < s.length; i++) {
		h ^= s.charCodeAt(i);
		// >>> 0 keeps this an unsigned 32-bit value; Math.imul is the standard
		// way to get a 32-bit multiply out of JS doubles.
		h = Math.imul(h, 0x01000193) >>> 0;
	}
	return h.toString(36);
}

export const contentVersionOf = (data: CourseData): string =>
	fnv1a(JSON.stringify([data.units, data.recipes, data.items.map((i) => i.id)]));

/** The content this build ships. */
export const CONTENT_VERSION: string = contentVersionOf(BUNDLED);
